export function consumeViewerToken() {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const supplied = fragment.get('access_token');
  if (supplied) {
    return supplied;
  }
  return sessionStorage.getItem('patient_portal_token') || localStorage.getItem('token');
}

export function authorizedViewerUrl(uid, token, configuredBase) {
  const trustedBase = String(process.env.REACT_APP_OHIF_URL || 'http://localhost:3001').replace(/\/+$/, '');
  const base = String(configuredBase || trustedBase).replace(/\/+$/, '');
  const parsed = new URL(base, window.location.origin);
  const trusted = new URL(trustedBase, window.location.origin);
  if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password || parsed.search || parsed.hash ||
      parsed.origin !== trusted.origin || parsed.pathname !== trusted.pathname) throw new Error('Unconfigured viewer origin');
  if (!token || !uid) throw new Error('Sign in to open this study');
  return `${base}/viewer/${encodeURIComponent(uid)}#access_token=${encodeURIComponent(token)}`;
}

export function savePdf(response, filename = 'report.pdf') {
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
